import { makeObservable, observable, runInAction, toJS } from 'mobx'
import storage from 'localforage'
import { set } from 'lodash'

export type ShareConfig = {
  /**
   * storageKey 存储 key，如果 isRemember 为 true，则就需要用 storageKey 去取本地缓存
   * 实际使用的共享数据 shareBase 还是以 shareKey 为键做赋值
   */
  [storageKey: string]: {
    shareKey: string,
    isRemember?: boolean,
    queryFields?: string[]
  }
}

class SearchStore {
  /**
   * 将初始化的步骤移动到 constructor 中，
   * 并且请务必初始化，否则 babel 插件 plugin-transform-flow-strip-types 编译失败，
   * 相关联 issue: 
   * https://github.com/react-navigation/react-navigation/issues/5825#issuecomment-590723220
   * https://github.com/facebook/react-native/issues/20150#issuecomment-417858270
   */
  /**
   * 更新对象类型的 store 时候，
   * 除非要观察整个对象，否则禁止完全重写整个对象，
   * 因为完全重写会导致观察该对象的所有组件都重新渲染
   */
  search: Map<string | undefined, any>
  // share 共享数据
  shareBase: { [shareKey: string]: any }

  constructor () {
    this.search = new Map()
    this.shareBase = {}

    makeObservable(this, {
      /**
       * 需要将其添加到 observable 中
       * 否则在 searchStore.search.get 的时候很可能只返回 undefined
       */
      search: observable,
      shareBase: observable,
    })
  }

  registerShareBase (shareConfig: ShareConfig): Promise<boolean> {
    return new Promise((resolve) => {
      const promiseFunc: any = []
      Object.keys(shareConfig).forEach(key => {
        const { shareKey, isRemember } = shareConfig[key]
        // shareBase 不存在 shareKey 对应资源时，表示该资源首次加载，需要初始化
        if (!this.shareBase[shareKey]) {
          runInAction(() => {
            set(this.shareBase, shareKey, {})
          })
          // 如果是记忆查询，则取本地缓存
          isRemember && promiseFunc.push(
            storage.getItem(key).then((data: any) => {
              this.setShareBase(shareKey, data)
            })
          )
        }
      })
      Promise.all(promiseFunc).finally(() => {
        // promiseFunc.length 代表取本地缓存，则说明是初次加载
        resolve(!!promiseFunc.length)
      })
    })
  }

  setShareBase (shareKey: string, data: any, storageKey?: string) {
    runInAction(() => {
      set(this.shareBase, shareKey, Object.assign({}, this.shareBase[shareKey], data))
    })
    storageKey && storage.setItem(storageKey, toJS(this.shareBase[shareKey]))
  }
}

const searchStore = new SearchStore()
export default searchStore